function initializeStickyCartBar(rootEl = document) {
  const bars = rootEl.querySelectorAll('[data-sticky-cart-bar]');
  if (bars.length === 0) return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  bars.forEach((bar) => {
    if (bar.dataset.stickyCartInitialized === 'true') return;
    bar.dataset.stickyCartInitialized = 'true';

    const sectionId = bar.dataset.sectionId;
    const stickySubmit = bar.querySelector('[data-sticky-cart-submit]');
    const stickyPrice = bar.querySelector('[data-sticky-cart-price]');
    const stickyButtonText = bar.querySelector('[data-sticky-cart-button-text]');
    const stickyImage = bar.querySelector('[data-sticky-cart-image]');

    let mainButtonVisible = true;
    let hasScrolledEnough = false;
    let variantUnsubscriber = null;

    const scrollThreshold = 160;

    const syncFromMainButton = () => {
      const liveMainButton = document.getElementById(bar.dataset.mainButtonId);
      if (!liveMainButton || !stickySubmit) return;

      const isDisabled =
        liveMainButton.hasAttribute('disabled') || liveMainButton.getAttribute('aria-disabled') === 'true';
      stickySubmit.disabled = isDisabled;

      if (!stickyButtonText) return;

      const mainLabel = liveMainButton.querySelector('span')?.textContent?.trim();
      if (mainLabel) {
        stickyButtonText.textContent = mainLabel;
      }
    };

    const updateVisibility = () => {
      const shouldShow = mobileQuery.matches && hasScrolledEnough && !mainButtonVisible;

      bar.classList.toggle('is-visible', shouldShow);
      bar.hidden = !shouldShow;
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    const onScroll = () => {
      hasScrolledEnough = window.scrollY > scrollThreshold;
      updateVisibility();
    };

    const setupIntersectionObserver = () => {
      bar._stickyCartObserver?.disconnect();

      const liveMainButton = document.getElementById(bar.dataset.mainButtonId);
      if (!liveMainButton || typeof IntersectionObserver === 'undefined') {
        mainButtonVisible = false;
        updateVisibility();
        return;
      }

      bar._stickyCartObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            mainButtonVisible = entry.isIntersecting;
            updateVisibility();
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -8px 0px' }
      );

      bar._stickyCartObserver.observe(liveMainButton);
    };

    setupIntersectionObserver();

    window.addEventListener('scroll', onScroll, { passive: true });
    mobileQuery.addEventListener('change', updateVisibility);

    onScroll();
    syncFromMainButton();

    stickySubmit?.addEventListener('click', () => {
      const liveMainButton = document.getElementById(bar.dataset.mainButtonId);
      if (!liveMainButton || liveMainButton.disabled) return;
      liveMainButton.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data || String(data.sectionId) !== String(sectionId)) return;

        const updatedPrice = data.html?.getElementById(`price-${sectionId}`);
        if (updatedPrice && stickyPrice) {
          stickyPrice.innerHTML = updatedPrice.innerHTML;
        }

        requestAnimationFrame(() => {
          setupIntersectionObserver();
          observeMainButton();
          syncFromMainButton();
        });

        const variant = data.variant;
        if (variant?.featured_media?.preview_image?.src && stickyImage) {
          stickyImage.src = variant.featured_media.preview_image.src;
        }
      });
    }

    const observeMainButton = () => {
      const liveMainButton = document.getElementById(bar.dataset.mainButtonId);
      if (!liveMainButton) return;

      if (bar._stickyCartMainButtonObserver) {
        bar._stickyCartMainButtonObserver.disconnect();
      }

      bar._stickyCartMainButtonObserver = new MutationObserver(() => syncFromMainButton());
      bar._stickyCartMainButtonObserver.observe(liveMainButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
        subtree: true,
        childList: true,
        characterData: true,
      });
    };

    observeMainButton();

    bar._stickyCartCleanup = () => {
      window.removeEventListener('scroll', onScroll);
      mobileQuery.removeEventListener('change', updateVisibility);
      bar._stickyCartObserver?.disconnect();
      bar._stickyCartMainButtonObserver?.disconnect();
      variantUnsubscriber?.();
    };
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initializeStickyCartBar();
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initializeStickyCartBar(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sticky-cart-bar]').forEach((bar) => {
      bar._stickyCartCleanup?.();
      bar.dataset.stickyCartInitialized = 'false';
    });
  });
}
